import { render, staticRenderFns } from "./AboutStudyPage.vue?vue&type=template&id=4d6b1a13&"
import script from "./AboutStudyPage.vue?vue&type=script&lang=js&"
export * from "./AboutStudyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports